import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';

export class EntitySchemaListView extends React.Component<EntitySchemaListViewProps, {}> {
	constructor(props: Readonly<EntitySchemaListViewProps>) {
		super(props);
	}

	rowKey = (record: EntitySchemaSummary) => record.name;

	render() {
		const { model } = this.props;
		const columns = [
			{
				key: 'name',
				title: 'Entity',
				dataIndex: 'name',
				render: (text, record: EntitySchemaSummary) => <Link to={`/general/entity-schemas/${record.name}`}>{text}</Link>,
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={columns}
						rowKey={this.rowKey}
						hideToolbar={ToolbarVisibility.hideModifyButtons}
						setBusy={this.props.setBusy}
						itemDoubleClick={(item) => {
							if (this.props.onItemDoubleClicked) {
								this.props.onItemDoubleClicked(item);
							}
						}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/entity-schemas/list/entity-schema-list.view.tsx